import { useState, useCallback } from "react";

import { message as antdMessage } from "antd";

import { Invoice } from "../bitmaker/schemas/Billing/Invoice";

import { BitmakerAPIClient } from "../services/BitmakerApp";

export function useInvoicePDF(invoice: Invoice | null) {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadInvoicePDF = useCallback(() => {
    if (!invoice?.id) return;

    setIsDownloading(true);

    antdMessage.info(`Downloading Invoice #${invoice.invoiceNumber} as PDF...`);

    BitmakerAPIClient.getBlob(
      `/billing/invoices/${invoice.id}/pdf`,
      null,
      (response) => {
        setIsDownloading(false);

        if (
          response &&
          response.status &&
          response.status >= 200 &&
          response.status < 300
        ) {
          const blobData = response.data;
          const url = window.URL.createObjectURL(blobData);

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Invoice-${invoice.invoiceNumber}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();

          window.URL.revokeObjectURL(url);

          antdMessage.success(
            `Invoice #${invoice.invoiceNumber} downloaded successfully.`,
          );
        } else {
          console.error("PDF Download Failed:", response);

          antdMessage.error(
            `Failed to download Invoice #${invoice.invoiceNumber}. Please try again.`,
          );
        }
      },
    );
  }, [invoice]);

  return {
    downloadInvoicePDF,
    isDownloading,
  };
}
